import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    imagePreview: null,
    imageName: null,
    isDeleted: false
}

export const digitalMagazineSlice = createSlice({
    name: 'digitalMagazine',
    initialState,
    reducers: {
        setImagePreview: (state, { payload }) => {
            state.imagePreview = payload
        },
        setImageName: (state, { payload }) => {
            state.imageName = payload
        },
        setIsDeleted: (state, { payload }) => {
            state.isDeleted = payload
        }
    }
})

export const { setImagePreview, setImageName, setIsDeleted } = digitalMagazineSlice.actions
export default digitalMagazineSlice.reducer
